module.exports = __webpack_public_path__ + "img/pic_ip@2x.5f21a09a.png";